import { render, staticRenderFns } from "./token-invalid.vue?vue&type=template&id=a689b68e&"
import script from "./token-invalid.vue?vue&type=script&lang=js&"
export * from "./token-invalid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./token-invalid-i18n.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fweb%2Fsrc%2Fviews%2Ferror%2Ftoken-invalid.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports